import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { color } from "src/styles/variables";

const STAR_HALF_FULL = 50;
const STAR_FULL = 100;
const STAR_SIZE_DEFAULT = 35;
const starsInitialArray = new Array(5).fill("");

function Stars({ value = 0, starSize = STAR_SIZE_DEFAULT }) {
  const [startsToFill, remainder = ""] = `${value}`.split(".");
  const remainderIndex = parseInt(startsToFill) + 1;
  return (
    <div aria-label={`Rating of ${value} out of 5.`}>
      {starsInitialArray.map((_, index) => {
        const starIndex = index + 1;
        const isFullStar = startsToFill % starIndex < startsToFill;
        const remainderPercentage =
          starIndex === remainderIndex && !!remainder ? STAR_HALF_FULL : 0;
        return (
          <Star
            key={`star-${starIndex}`}
            fill={isFullStar ? STAR_FULL : remainderPercentage}
            starSize={starSize}
          >
            ☆
          </Star>
        );
      })}
    </div>
  );
}

Stars.propTypes = {
  value: PropTypes.number,
  starSize: PropTypes.number,
};

export default Stars;

const Star = styled.span`
  font-size: ${({ starSize }) => `${starSize}px`};
  color: ${color.gold};
  position: relative;

  &:after {
    color: ${color.gold};
    content: "★";
    position: absolute;
    left: 0;
    overflow: hidden;
    width: ${({ fill }) => `${fill}%`};
  }
`;
